module.exports = __webpack_public_path__ + "img/zwxc.a3a22514.png";